"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportedLanguage = void 0;
var SupportedLanguage;
(function (SupportedLanguage) {
    SupportedLanguage["DA"] = "da";
    SupportedLanguage["SV"] = "sv";
    SupportedLanguage["EN"] = "en";
    SupportedLanguage["DE"] = "de";
    SupportedLanguage["ES"] = "es";
    SupportedLanguage["FR"] = "fr";
    SupportedLanguage["FI"] = "fi";
    SupportedLanguage["NL"] = "nl";
    SupportedLanguage["DE_AT"] = "de-AT";
    SupportedLanguage["FR_BE"] = "fr-BE";
    SupportedLanguage["NL_BE"] = "nl-BE";
    SupportedLanguage["NO"] = "no";
    SupportedLanguage["ET"] = "et";
    SupportedLanguage["IT"] = "it";
    SupportedLanguage["PL"] = "pl";
    SupportedLanguage["PT"] = "pt";
})(SupportedLanguage = exports.SupportedLanguage || (exports.SupportedLanguage = {}));
//# sourceMappingURL=supported-language.js.map